// Bản đồ giao diện (chỉ Super): xem thao tác theo mạng, sức khoẻ (bot báo lỗi ở thao tác nào), lịch sử phiên bản, sửa thành nháp, tạm ngưng,
// khôi phục phiên bản cũ, nhập tệp khảo sát / khối tuỳ chỉnh, xuất, và PHÁT HÀNH bản đồ mới (Boss web, bot và AI đều dùng bản phát hành).
// Sửa/tạm ngưng/khôi phục chỉ đổi "bản sẽ phát hành tới"; bấm Phát hành mới có hiệu lực. Mọi chữ từ máy chủ/tệp đều vào textContent.
import { api, errMsg } from "../api";
import { busy, clear, confirmBox, gen, h, toast } from "../dom";
import { fmtTime } from "../format";
import { isSuper } from "../store";
import { noPermission } from "./users";
import { chiaGoiNhap } from "../nhap-lon";
import { renderGiaoDienTab } from "./ban-do-giao-dien";
import { demDeXuat, renderDeXuatTab } from "./ban-do-de-xuat";

interface SucKhoe { muc: "tot" | "nghi" | "hong"; soBot: number; soLoi: number; tuLuc: string | null; lanCuoi: string | null; giaoDienDoi?: boolean; chuaChac?: number }
interface PhanTuDung { trang: string; nhan: string; css: string | null; trangThai: "con" | "mat" | "moi" | "khong_thay" }
interface Dong {
  id: string; nenTang: string; ma: string; moTa: string; ruiRo: "thap" | "cao"; pbDangDung: number | null; pbMucTieu: number | null; pbMoiNhat: number | null;
  trangThai: "dang_dung" | "tam_ngung" | "nhap_moi"; choPhatHanh: boolean; nguon: string | null; trangThu: string | null; sucKhoe: SucKhoe;
}
interface NenTang { ma: string; ten: string; url: string; ghiChu: string | null; soThaoTac: number; soHong: number }
interface QuanLy {
  ban: { so: number; hash: string; luc: string; boi: string | null; ghiChu: string | null } | null;
  nenTang: NenTang[]; thaoTac: Dong[]; tong: number; trang: number; co: number; soChoPhatHanh: number; soHong: number; soNghi: number;
}
interface ThayDoi { id: string; nenTang: string; ma: string; loai: "them" | "sua" | "ngung" | "khoi_phuc"; tu: number | null; den: number | null }
interface Pb { pb: number; trangThai: string; nguon: string; trangThu: string | null; ghiChu: string | null; taoBoi: string | null; taoLuc: string; thaoTac: Record<string, unknown> }
interface Loi { botId: string; botName: string | null; stepId: string; loai: string; lyDo: string | null; runId: string; pb: number; banDoSo: number; luc: string }
interface GoiYTc { css: string; nhan: string; vaiTro: string | null; trang: string; trangThai: "con" | "moi"; diem: number }
interface MucTieuTc { buoc: string; kind: string; mota: string; trangThai: "khop" | "khong_thay" | "chua_co_khao_sat"; xacNhan: number; goiY: GoiYTc[]; baoCao?: { dung: number; sai: number; ganNhat: string | null }; tinCay?: "thap" | "binh_thuong" }
interface ThamChieuTc { ma: string; nenTang: string; mucTieu: MucTieuTc[] }
interface ChiTiet { id: string; nenTang: string; ma: string; urlNenTang: string; pbDangDung: number | null; pbMucTieu: number | null; phienBan: Pb[]; loi: Loi[]; sucKhoe: SucKhoe; phanTuDung?: PhanTuDung[] }
interface BanPh { so: number; ghiChu: string | null; thayDoi: ThayDoi[]; taoBoi: string | null; taoLuc: string; soThaoTac: number }
// Áp dụng bản mới cho kịch bản sơ đồ (mục 6): xem trước trước khi phát hành + kết quả sau khi phát hành.
interface KbNgan { id: string; ten: string; lyDo: string }
interface AnhHuong { thayDoi: number; kichBan: { id: string; ten: string; ownerName: string | null; nenTang: string; thaoTac: string[] }[]; tong: number }
interface ApDung {
  anhHuong: number; doiHash: number; khongDoi: number; loiDich: KbNgan[];
  nhapLai: { bat: boolean; daChay: number; boQua: KbNgan[] }; loiApDung: KbNgan[];
}
interface KqPhatHanh { so: number; apDung?: ApDung }

const NHAN_LOAI: Record<ThayDoi["loai"], string> = { them: "thêm mới", sua: "bản sửa mới", ngung: "tạm ngưng", khoi_phuc: "khôi phục bản cũ" };
const NHAN_NGUON: Record<string, string> = { co_san: "khối có sẵn", khao_sat: "khảo sát", super_day: "Super tự dạy", khoi_tuy_chinh: "khối tuỳ chỉnh", nhap_tep: "nhập từ tệp" };
const NHAN_TT: Record<string, string> = { dang_dung: "đang dùng", tam_ngung: "tạm ngưng", nhap_moi: "nháp (chưa phát hành)", nhap: "nháp", cu: "cũ", tu_choi: "đã bỏ" };
const NHAN_LOI: Record<string, string> = { khong_tim_thay: "không tìm thấy phần tử", hau_kiem: "hậu kiểm thất bại", khac: "lỗi khác", chua_chac: "chưa chắc (không tính)" };
const TOI_DA_TEP = 20 * 1024 * 1024;

function tagSucKhoe(s: SucKhoe): HTMLElement {
  const nhan = s.muc === "hong" ? "Hỏng" : s.muc === "nghi" ? "Nghi" : "Tốt";
  const gd = s.giaoDienDoi === true;
  const tipBot = `Lỗi trên ${s.soBot} bot (${s.soLoi} lần) từ ${s.tuLuc ? fmtTime(s.tuLuc) : "?"}; gần nhất ${s.lanCuoi ? fmtTime(s.lanCuoi) : "?"}`;
  const tipGd = "Khảo sát mới cho thấy có nút/ô mà thao tác này dùng đã biến mất khỏi trang — giao diện mạng xã hội có thể đã đổi, cần khảo sát lại rồi sửa thao tác";
  const tip = s.muc === "tot" ? "Không có bot nào báo lỗi ở thao tác này trong 24 giờ qua (hoặc đã chạy đạt sau lỗi)"
    : s.soBot === 0 ? tipGd : gd ? `${tipBot}. Đồng thời: ${tipGd}` : tipBot;
  const chu = s.muc === "tot" ? nhan : s.soBot === 0 ? `${nhan} · giao diện đổi` : `${nhan} · ${s.soBot} bot${gd ? " + giao diện đổi" : ""}`;
  return h("span", { class: `tag ${s.muc === "hong" ? "err" : s.muc === "nghi" ? "warn" : "ok"}`, title: tip, "data-testid": "bd-suc-khoe", dataset: { muc: s.muc, giaoDienDoi: gd ? "1" : "0" } }, chu);
}

// L-87: lỗi bot báo mà CHƯA CHẮC do giao diện (việc có thể đã xong, hộp thoại che, captcha, mạng…) — hiện riêng, không làm thao tác Nghi/Hỏng.
function tagChuaChac(s: SucKhoe): HTMLElement | null {
  const n = s.chuaChac ?? 0;
  if (n <= 0) return null;
  return h("span", { class: "tag", style: "margin-left:4px", "data-testid": "bd-chua-chac", title: `${n} lỗi bot báo trong 24 giờ qua nhưng CHƯA CHẮC do giao diện (việc có thể đã xong theo cách khác, hộp thoại che, trang bắt xác minh, lỗi mạng…) — không tính vào Nghi/Hỏng. Bấm vào thao tác để xem lý do từng lỗi.` }, `${n} chưa chắc`);
}

// Một bản phát hành có thể đổi hàng nghìn thao tác — chỉ liệt kê vài cái đầu rồi ghi tổng số, nếu không ô này dài hàng chục nghìn điểm ảnh.
const TOI_DA_TOM_TAT = 8;
const TOI_DA_XEM_TRUOC = 100;
/** Cột "Thay đổi" của Lịch sử phát hành: MỖI thay đổi một dòng (trước đây nối thành một chuỗi dài trong ô 140 px → ở 390 px bị ép
 *  gần một chữ mỗi dòng). Tối đa TOI_DA_TOM_TAT dòng + dòng "… và N thay đổi khác". */
function tomTatThayDoi(ds: ThayDoi[]): HTMLElement {
  const ul = h("ul", { class: "bd-thay-doi-ds" }, ...ds.slice(0, TOI_DA_TOM_TAT).map((t) => h("li", {}, h("span", { class: "bd-ma" }, `${t.nenTang}/${t.ma}`), `: ${NHAN_LOAI[t.loai] ?? t.loai}`)));
  if (ds.length > TOI_DA_TOM_TAT) ul.append(h("li", { class: "muted" }, `… và ${ds.length - TOI_DA_TOM_TAT} thay đổi khác (${ds.length} thay đổi)`));
  return ul;
}

// Danh sách dài (hàng trăm kịch bản) chỉ hiện vài dòng đầu + tổng số, nếu không hộp/khối kết quả dài hàng chục nghìn điểm ảnh.
const TOI_DA_KICH_BAN = 10;
const TOI_DA_DONG_KQ = 30;
const CHO_XEM_TRUOC_MS = 8000;

/** Phần "xem trước" trong hộp xác nhận: bao nhiêu kịch bản sơ đồ đang dùng các thao tác này sẽ được dịch lại. */
function veXemTruoc(box: HTMLElement, r: AnhHuong): void {
  clear(box);
  const tong = Math.max(r.tong, r.kichBan.length);
  if (tong === 0) {
    box.append(h("p", { class: "small", "data-testid": "bd-anh-huong-so" }, "Chưa có kịch bản sơ đồ nào dùng các thao tác này — phát hành không làm đổi kịch bản nào."));
    return;
  }
  const hien = r.kichBan.slice(0, TOI_DA_KICH_BAN);
  box.append(
    h("p", { class: "small" }, h("b", { "data-testid": "bd-anh-huong-so" }, `${tong} kịch bản sơ đồ`), " đang dùng các thao tác này sẽ được dịch lại theo bản đồ mới:"),
    h("ul", { class: "small bda-list", "data-testid": "bd-anh-huong-ds" },
      ...hien.map((k) => h("li", { "data-testid": "bd-anh-huong-kb" }, h("span", { class: "bda-ten" }, k.ten || "(không tên)"), k.ownerName ? h("span", { class: "muted" }, ` — ${k.ownerName}`) : null)),
      tong > hien.length ? h("li", { class: "muted", "data-testid": "bd-anh-huong-them" }, `… và ${tong - hien.length} kịch bản khác`) : null),
    h("p", { class: "muted small" }, "Kịch bản nào đổi bản dịch thì lần chạy sau dùng bản dịch mới. Bản đồ mới không bao giờ tự chạy thật."));
}

function dsLoiKb(ds: KbNgan[], testid: string): HTMLElement {
  const hien = ds.slice(0, TOI_DA_DONG_KQ);
  return h("ul", { class: "small bda-list", "data-testid": testid },
    ...hien.map((k) => h("li", {}, h("b", { class: "bda-ten" }, k.ten || "(không tên)"), h("span", {}, ` — ${k.lyDo}`))),
    ds.length > hien.length ? h("li", { class: "muted" }, `… và ${ds.length - hien.length} kịch bản khác`) : null);
}

/** Khối kết quả hiện ngay đầu trang sau khi phát hành: nói bằng chữ điều gì đã xảy ra với kịch bản sơ đồ. */
function veKetQuaApDung(box: HTMLElement, so: number, a: ApDung): void {
  clear(box);
  const coLoi = a.loiDich.length > 0 || a.loiApDung.length > 0;
  box.className = `bda-result ${coLoi ? "bda-has-err" : ""}`;
  box.hidden = false;
  box.append(h("div", { class: "row" }, h("h3", { class: "grow bda-h" }, `Kết quả áp dụng bản đồ #${so} cho kịch bản sơ đồ`),
    h("button", { type: "button", class: "mini", title: "Ẩn khối kết quả này (không xoá gì)", "data-testid": "bd-apdung-dong", onclick: () => { box.hidden = true; clear(box); } }, "Đóng")));
  if (a.anhHuong === 0 && !coLoi) {
    box.append(h("p", { "data-testid": "bd-apdung-tom" }, "Chưa kịch bản sơ đồ nào dùng các thao tác đã đổi — không có kịch bản nào cần dịch lại."));
  } else if (a.anhHuong === 0) {
    box.append(h("p", { "data-testid": "bd-apdung-tom" }, "Bản đồ đã phát hành nhưng chưa áp dụng được cho kịch bản sơ đồ nào — xem lỗi bên dưới."));
  } else {
    // (đặc tả đổi 08/10/2026, bỏ Nháp; sửa 12/10/2026) trước: "N cần nháp lại (lần chạy sau dùng bản dịch mới)" — không còn cổng nháp nên "cần nháp lại" sai nghĩa; máy chủ cũng đã bỏ câu đó (ban-do-ap-dung.ts).
    box.append(h("p", { "data-testid": "bd-apdung-tom" },
      `Đã dịch lại ${a.anhHuong} kịch bản sơ đồ dùng các thao tác đã đổi: `, h("b", {}, `${a.doiHash} có bản dịch mới`), ` (lần bấm Chạy tới dùng bản này), ${a.khongDoi} không đổi${a.loiDich.length ? `, ${a.loiDich.length} lỗi dịch` : ""}.`));
  }
  if (a.loiDich.length) {
    box.append(h("div", { class: "bda-err", role: "alert", "data-testid": "bd-apdung-loi" },
      h("p", { class: "bda-err-h" }, `⚠ ${a.loiDich.length} kịch bản LỖI dịch — chưa áp dụng được bản đồ mới, cần mở ra xem lại (thường vì thao tác bị tạm ngưng):`),
      dsLoiKb(a.loiDich, "bd-apdung-loi-ds")));
  }
  if (a.loiApDung.length) {
    box.append(h("div", { class: "bda-err", role: "alert", "data-testid": "bd-apdung-loi-luu" },
      h("p", { class: "bda-err-h" }, `⚠ ${a.loiApDung.length} kịch bản gặp lỗi khi lưu bản dịch mới:`),
      dsLoiKb(a.loiApDung, "bd-apdung-loi-luu-ds")));
  }
  if (!a.nhapLai.bat) {
    box.append(h("p", { class: "muted small", "data-testid": "bd-apdung-nhap" }, "Chạy nháp lại tự động: tắt."));
  } else {
    box.append(h("p", { "data-testid": "bd-apdung-nhap" }, `Chạy nháp lại tự động: đã chạy ${a.nhapLai.daChay}, bỏ qua ${a.nhapLai.boQua.length}${a.nhapLai.boQua.length ? " (lý do bên dưới)" : ""}. Chỉ nháp — không có kịch bản nào tự chạy thật.`));
    if (a.nhapLai.boQua.length) box.append(dsLoiKb(a.nhapLai.boQua, "bd-apdung-bo-qua"));
  }
}

function docTep(f: File): Promise<string> {
  return new Promise((ok, loi) => {
    const r = new FileReader();
    r.onload = () => ok(String(r.result ?? ""));
    r.onerror = () => loi(new Error(`Không đọc được tệp “${f.name}”`));
    r.readAsText(f, "utf-8");
  });
}

export async function renderBanDo(root: HTMLElement): Promise<() => void> {
  if (!isSuper()) return noPermission(root, "Bản đồ giao diện");
  const alive = gen("ban-do");
  let data: QuanLy | null = null;
  let nenTang = "";
  let q = "";
  let trang = 1;
  let chon: string | null = null; // id thao tác đang xem chi tiết

  const info = h("p", { class: "muted small", "data-testid": "bd-info" }, "Đang tải…");
  const loiBox = h("div", { class: "err-box", hidden: true, "data-testid": "bd-error" });
  const btnPh = h("button", { type: "button", class: "pri", disabled: true, title: "Phát hành các thay đổi đang chờ thành bản đồ mới — Boss web và bot nhận bản mới ngay", "data-testid": "bd-publish" }, "Phát hành");
  const btnNhap = h("button", { type: "button", title: "Nhập tệp ban-do-giao-dien-*.json (khảo sát của bot), khối tuỳ chỉnh của bot, hoặc bản đồ xuất từ Boss khác", "data-testid": "bd-import" }, "Nhập tệp…");
  const tep = h("input", { type: "file", accept: ".json,application/json", hidden: true, "data-testid": "bd-file" });
  const btnXuat = h("button", { type: "button", title: "Tải bản đồ đang phát hành về máy (JSON)", "data-testid": "bd-export" }, "Xuất");
  const tabs = h("div", { class: "row", role: "tablist", "data-testid": "bd-tabs" });
  const tim = h("input", { type: "search", placeholder: "Lọc theo mã hoặc mô tả…", title: "Gõ một phần mã hoặc mô tả thao tác để lọc", "data-testid": "bd-search" });
  const tbody = h("tbody", { "data-testid": "bd-rows" });
  const trangBox = h("div", { class: "row", "data-testid": "bd-paging" });
  const chiTiet = h("div", { class: "card", hidden: true, "data-testid": "bd-detail" });
  const lichSu = h("div", { class: "card", "data-testid": "bd-history" });

  // Hai tầng của bản đồ: "Thao tác" (chuỗi bấm/gõ đã kiểm thật, có phiên bản + phát hành) và "Giao diện" (mạng → trang → phần tử, từ khảo sát).
  const vungThaoTac = h("div", { "data-testid": "bd-vung-thao-tac" },
    h("div", { class: "toolbar row" }, btnPh, btnNhap, tep, btnXuat, h("span", { class: "grow" }), info),
    loiBox, tabs,
    h("div", { class: "toolbar row bd-khong-dinh" }, tim),
    h("div", { class: "tbl" }, h("table", { "data-testid": "bd-table" },
      h("thead", {}, h("tr", {}, h("th", {}, "Thao tác"), h("th", {}, "Mô tả"), h("th", { title: "cao = có bước đăng/bình luận/thích thật" }, "Rủi ro"), h("th", {}, "Trạng thái"), h("th", { title: "Phiên bản đang phát hành → phiên bản sẽ phát hành tới" }, "Phiên bản"), h("th", {}, "Nguồn"), h("th", { title: "Bot báo lỗi ở thao tác này trong 24 giờ qua" }, "Sức khoẻ"))),
      tbody)),
    trangBox, chiTiet, lichSu);
  const apDungBox = h("div", { class: "bda-result", hidden: true, role: "status", "data-testid": "bd-apdung" });
  const vungGd = h("div", { hidden: true, "data-testid": "bd-vung-giao-dien" });
  const vungDx = h("div", { hidden: true, "data-testid": "bd-vung-de-xuat" });
  let dxDaVe = false;
  let huyGd: (() => void) | null = null;
  let gdDaVe = false;
  const tabThaoTac = h("button", { type: "button", role: "tab", class: "mini pri", "aria-selected": "true", title: "Các thao tác đã kiểm thật (bấm gì, gõ gì) theo từng mạng, có phiên bản và phát hành", "data-testid": "bd-tab-thao-tac" }, "Thao tác");
  const tabGd = h("button", { type: "button", role: "tab", class: "mini", "aria-selected": "false", title: "Giao diện từng mạng xã hội: các trang và các nút/ô trên mỗi trang, lấy từ khảo sát của bot", "data-testid": "bd-tab-giao-dien" }, "Giao diện");
  const tabDx = h("button", { type: "button", role: "tab", class: "mini", "aria-selected": "false", title: "Bản nháp chưa được chọn: bot đề xuất, thư viện khối đổi mà bạn đã tự sửa, nhập từ tệp — chọn để phát hành hoặc bỏ", "data-testid": "bd-tab-de-xuat" }, "Đề xuất");
  const veDem = (n: number): void => { tabDx.textContent = n > 0 ? `Đề xuất (${n})` : "Đề xuất"; tabDx.dataset.dem = String(n); };
  const chonTang = (tang: "thao" | "gd" | "dx"): void => {
    for (const [nut, ten] of [[tabThaoTac, "thao"], [tabGd, "gd"], [tabDx, "dx"]] as const) { nut.className = `mini ${tang === ten ? "pri" : ""}`; nut.setAttribute("aria-selected", String(tang === ten)); }
    vungThaoTac.hidden = tang !== "thao"; vungGd.hidden = tang !== "gd"; vungDx.hidden = tang !== "dx";
    if (tang === "thao") void tai(); // vừa chọn/bỏ đề xuất ở tab khác → "N chờ phát hành" và nút Phát hành phải theo kịp, không chờ tải lại trang
    if (tang === "gd" && !gdDaVe) {
      gdDaVe = true;
      void renderGiaoDienTab(vungGd).then((huy) => { huyGd = huy; }).catch((e) => { gdDaVe = false; vungGd.append(h("div", { class: "err-box", "data-testid": "bd-gd-error" }, errMsg(e))); });
    }
    if (tang === "dx") {
      // Vẽ lại mỗi lần vào tab: danh sách đổi theo việc bot đề xuất / Super chọn.
      clear(vungDx); dxDaVe = true;
      void renderDeXuatTab(vungDx, { moChiTiet: (id) => { chonTang("thao"); chon = id; void moChiTiet(id); }, capNhatDem: veDem })
        .catch((e) => { dxDaVe = false; vungDx.append(h("div", { class: "err-box", "data-testid": "bd-dx-error" }, errMsg(e))); });
    }
  };
  tabThaoTac.addEventListener("click", () => chonTang("thao"));
  tabGd.addEventListener("click", () => chonTang("gd"));
  tabDx.addEventListener("click", () => chonTang("dx"));
  root.append(h("h1", {}, "Bản đồ giao diện"),
    h("p", { class: "muted small" }, "Bản đồ gồm hai tầng. GIAO DIỆN: các trang của từng mạng xã hội và những nút/ô trên trang (từ khảo sát của bot) — để AI biết bấm vào đâu. THAO TÁC: chuỗi bấm/gõ đã kiểm thật ghép từ các phần tử đó. Kịch bản sơ đồ và AI chỉ lắp từ thao tác trong bản đồ ĐÃ PHÁT HÀNH; sửa, tạm ngưng hay khôi phục chỉ có hiệu lực sau khi bạn bấm Phát hành."),
    apDungBox,
    h("div", { class: "row", role: "tablist", "data-testid": "bd-tang" }, tabThaoTac, tabGd, tabDx),
    vungThaoTac, vungGd, vungDx);

  function baoLoi(e: unknown): void {
    loiBox.textContent = errMsg(e);
    loiBox.hidden = false;
  }
  const hetLoi = (): void => { loiBox.hidden = true; loiBox.textContent = ""; };

  function veTabs(): void {
    clear(tabs);
    if (!data) return;
    const them = (ma: string, ten: string, n: number, hong: number): void => {
      tabs.append(h("button", { type: "button", role: "tab", class: `mini ${nenTang === ma ? "pri" : ""}`, "aria-selected": String(nenTang === ma), "data-testid": `bd-tab-${ma || "tat-ca"}`,
        title: hong ? `${hong} thao tác đang có lỗi` : `${n} thao tác`, onclick: () => { nenTang = ma; trang = 1; chon = null; void tai(); } }, `${ten} (${n})${hong ? " ⚠" + hong : ""}`));
    };
    them("", "Tất cả", data.nenTang.reduce((s, n) => s + n.soThaoTac, 0), data.soHong + data.soNghi);
    // Nền tảng chưa có thao tác nào (vd Reddit: mới có bản đồ giao diện) không có nút lọc trống ở tab Thao tác — nó nằm ở tab Giao diện.
    for (const n of data.nenTang) if (n.soThaoTac > 0 || n.ma === nenTang) them(n.ma, n.ten, n.soThaoTac, n.soHong);
  }

  function veBang(): void {
    clear(tbody);
    if (!data) return;
    if (!data.thaoTac.length) tbody.append(h("tr", {}, h("td", { colspan: 7, class: "empty", "data-testid": "bd-empty" }, q || nenTang ? "Không có thao tác nào khớp bộ lọc." : "Bản đồ chưa có thao tác nào.")));
    for (const t of data.thaoTac) {
      const pbTxt = `${t.pbDangDung !== null ? "v" + t.pbDangDung : t.trangThai === "tam_ngung" ? "tạm ngưng" : "—"}${t.choPhatHanh ? ` → ${t.pbMucTieu !== null ? "v" + t.pbMucTieu : "tạm ngưng"}` : ""}`;
      const tr = h("tr", { "data-testid": "bd-row", class: t.id === chon ? "sel" : "", dataset: { id: t.id, nenTang: t.nenTang, ma: t.ma }, style: "cursor:pointer", title: "Bấm để xem chi tiết, lịch sử phiên bản và sửa",
        onclick: () => { chon = t.id; veBang(); void moChiTiet(t.id); } },
        h("td", { class: "name bd-name" }, h("span", {}, `${t.nenTang}/${t.ma}`)),
        h("td", { class: "wrap small bd-mota" }, t.moTa),
        h("td", {}, h("span", { class: `tag ${t.ruiRo === "cao" ? "warn" : ""}` }, t.ruiRo === "cao" ? "cao" : "thấp")),
        h("td", {}, h("span", { class: `tag ${t.trangThai === "dang_dung" ? "ok" : t.trangThai === "tam_ngung" ? "err" : ""}`, "data-testid": "bd-trang-thai" }, NHAN_TT[t.trangThai] ?? t.trangThai)),
        h("td", { class: "nowrap small", "data-testid": "bd-pb", title: t.choPhatHanh ? "Có thay đổi chờ phát hành" : "" }, pbTxt, t.choPhatHanh ? h("i", { class: "tag warn", style: "font-style:normal;margin-left:4px" }, "chờ") : null),
        h("td", { class: "small" }, t.nguon ? NHAN_NGUON[t.nguon] ?? t.nguon : "—"),
        h("td", {}, tagSucKhoe(t.sucKhoe), tagChuaChac(t.sucKhoe)));
      tbody.append(tr);
    }
    clear(trangBox);
    const soTrang = Math.max(1, Math.ceil(data.tong / data.co));
    if (soTrang > 1) {
      trangBox.append(
        h("button", { type: "button", class: "mini", disabled: trang <= 1, title: "Về trang trước của danh sách thao tác", "data-testid": "bd-prev", onclick: () => { trang--; void tai(); } }, "← Trước"),
        h("span", { class: "small", "data-testid": "bd-page" }, `Trang ${data.trang}/${soTrang} · ${data.tong} thao tác`),
        h("button", { type: "button", class: "mini", disabled: trang >= soTrang, title: "Sang trang sau của danh sách thao tác", "data-testid": "bd-next", onclick: () => { trang++; void tai(); } }, "Sau →"));
    }
  }

  function veDau(): void {
    if (!data) return;
    const b = data.ban;
    info.textContent = b
      ? `Bản đồ #${b.so} · phát hành ${fmtTime(b.luc)}${b.boi ? ` bởi ${b.boi}` : ""} · ${data.nenTang.reduce((s, n) => s + n.soThaoTac, 0)} thao tác · ${data.soChoPhatHanh} chờ phát hành · ${data.soHong} hỏng · ${data.soNghi} nghi`
      : "Chưa có bản đồ nào được phát hành";
    btnPh.textContent = `Phát hành bản #${(b?.so ?? 0) + 1}`;
    btnPh.disabled = data.soChoPhatHanh === 0;
    btnPh.title = data.soChoPhatHanh ? `Có ${data.soChoPhatHanh} thay đổi chờ — bấm để xem rồi phát hành` : "Chưa có thay đổi nào để phát hành";
  }

  async function tai(): Promise<void> {
    try {
      const qs = new URLSearchParams();
      if (nenTang) qs.set("nenTang", nenTang);
      if (q) qs.set("q", q);
      if (trang > 1) qs.set("trang", String(trang));
      const d = await api<QuanLy>("GET", `/api/ban-do/quan-ly${qs.size ? `?${qs}` : ""}`);
      if (!alive()) return;
      data = d;
      trang = d.trang;
      hetLoi();
      veDau(); veTabs(); veBang();
    } catch (e) {
      if (!alive()) return;
      info.textContent = "Không tải được bản đồ";
      baoLoi(e);
    }
  }

  async function taiLichSu(): Promise<void> {
    try {
      const ds = await api<BanPh[]>("GET", "/api/ban-do/phat-hanh");
      if (!alive()) return;
      clear(lichSu);
      lichSu.append(h("h3", {}, "Lịch sử phát hành"));
      if (!ds.length) { lichSu.append(h("p", { class: "empty" }, "Chưa phát hành lần nào.")); return; }
      lichSu.append(h("div", { class: "tbl" }, h("table", { "data-testid": "bd-history-table" },
        h("thead", {}, h("tr", {}, h("th", {}, "Bản"), h("th", {}, "Lúc"), h("th", {}, "Bởi"), h("th", {}, "Thao tác"), h("th", {}, "Thay đổi"), h("th", {}, "Ghi chú"))),
        h("tbody", {}, ...ds.map((b) => h("tr", { "data-testid": "bd-history-row" },
          h("td", {}, `#${b.so}`), h("td", { class: "nowrap small" }, fmtTime(b.taoLuc)), h("td", {}, b.taoBoi ?? "hệ thống"), h("td", {}, String(b.soThaoTac)),
          h("td", { class: "small bd-thay-doi" }, b.thayDoi.length ? tomTatThayDoi(b.thayDoi) : "—"),
          h("td", { class: "small wrap" }, b.ghiChu ?? "")))))));
    } catch (e) {
      if (alive()) { clear(lichSu); lichSu.append(h("p", { class: "err small" }, `Không tải được lịch sử phát hành: ${errMsg(e)}`)); }
    }
  }

  async function moChiTiet(id: string): Promise<void> {
    chiTiet.hidden = false;
    clear(chiTiet);
    chiTiet.append(h("p", { class: "muted", "data-testid": "bd-detail-loading" }, "Đang tải chi tiết…"));
    let ct: ChiTiet;
    try {
      ct = await api<ChiTiet>("GET", `/api/ban-do/thao-tac/${encodeURIComponent(id)}`);
    } catch (e) {
      if (alive() && chon === id) { clear(chiTiet); chiTiet.append(h("div", { class: "err-box", "data-testid": "bd-detail-error" }, errMsg(e))); }
      return;
    }
    if (!alive() || chon !== id) return;
    veChiTiet(ct);
  }

  function veChiTiet(ct: ChiTiet): void {
    clear(chiTiet);
    const moiNhat = ct.phienBan[0];
    const soan = h("textarea", { rows: 16, spellcheck: "false", class: "bd-code", "data-testid": "bd-editor", title: "Nội dung thao tác dạng JSON (mô tả, tham số, yamlSteps, learned…). Lưu sẽ tạo phiên bản NHÁP mới — chưa ảnh hưởng ai cho tới khi phát hành." });
    soan.value = JSON.stringify(moiNhat?.thaoTac ?? {}, null, 2);
    const trangThu = h("input", { type: "url", placeholder: "Trang thử (https://…) — nơi thao tác này đã được kiểm", title: "Địa chỉ trang đã dùng để thử thao tác này (ghi chú cho người sau)", "data-testid": "bd-trang-thu" });
    trangThu.value = moiNhat?.trangThu ?? "";
    const loiSoan = h("p", { class: "err small", hidden: true, "data-testid": "bd-editor-error" });
    const hienLoi = (m: string): void => { loiSoan.textContent = m; loiSoan.hidden = false; };
    const doc = (): Record<string, unknown> | null => {
      loiSoan.hidden = true;
      const txt = soan.value.trim();
      if (!txt) { hienLoi("Ô JSON đang trống — dán nội dung thao tác vào rồi lưu."); return null; }
      try {
        const o = JSON.parse(txt) as unknown;
        if (!o || typeof o !== "object" || Array.isArray(o)) { hienLoi("Nội dung phải là một object JSON { … }."); return null; }
        return o as Record<string, unknown>;
      } catch (e) {
        hienLoi(`JSON chưa đúng: ${errMsg(e)}`);
        return null;
      }
    };
    const luuMoi = h("button", { type: "button", class: "pri", title: "Lưu thành phiên bản nháp MỚI của thao tác này và chọn nó cho bản phát hành tới", "data-testid": "bd-save-new" }, "Lưu thành phiên bản mới");
    luuMoi.addEventListener("click", () => void busy(luuMoi, "Đang lưu…", async () => {
      const t = doc();
      if (!t) return;
      try {
        const r = await api<{ pb: number; trung: boolean }>("POST", "/api/ban-do/thao-tac", { nenTang: ct.nenTang, thaoTac: t, nguon: "super_day", trangThu: trangThu.value.trim() || null });
        toast(r.trung ? `Nội dung trùng với v${r.pb} — không tạo thêm phiên bản` : `Đã lưu nháp v${r.pb} — bấm Phát hành để áp dụng`);
        await Promise.all([tai(), moChiTiet(ct.id)]);
      } catch (e) {
        hienLoi(errMsg(e));
        const lst = (e as { details?: { loi?: string[] } }).details?.loi;
        if (lst?.length) hienLoi(lst.join(" · "));
      }
    }));
    const ngung = h("button", { type: "button", class: "danger", disabled: ct.pbMucTieu === null, title: ct.pbMucTieu === null ? "Thao tác đã được đặt tạm ngưng (chờ phát hành)" : "Bỏ thao tác này khỏi bản đồ ở lần phát hành tới — khôi phục lại được", "data-testid": "bd-pause" }, "Tạm ngưng");
    ngung.addEventListener("click", () => void busy(ngung, "…", async () => {
      const ok = await confirmBox({ title: `Tạm ngưng ${ct.nenTang}/${ct.ma}?`, text: "Thao tác sẽ biến khỏi bản đồ khi bạn bấm Phát hành. Kịch bản sơ đồ đang dùng thao tác này sẽ không lắp mới được cho tới khi khôi phục.", okText: "Tạm ngưng", danger: true });
      if (!ok) return;
      try { await api("POST", `/api/ban-do/thao-tac/${encodeURIComponent(ct.id)}/tam-ngung`, {}); toast("Đã đặt tạm ngưng — bấm Phát hành để áp dụng"); await Promise.all([tai(), moChiTiet(ct.id)]); } catch (e) { baoLoi(e); }
    }));

    const bangPb = h("tbody", { "data-testid": "bd-versions" }, ...ct.phienBan.map((p) => {
      const laMucTieu = ct.pbMucTieu === p.pb;
      const dung = h("button", { type: "button", class: "mini", disabled: laMucTieu, title: laMucTieu ? "Đây đang là phiên bản sẽ phát hành tới" : `Chọn v${p.pb} cho bản phát hành tới (khôi phục nếu là bản cũ)`, "data-testid": "bd-use", dataset: { pb: String(p.pb) } }, laMucTieu ? "Đang chọn" : "Dùng bản này");
      dung.addEventListener("click", () => void busy(dung, "…", async () => {
        try { await api("POST", `/api/ban-do/thao-tac/${encodeURIComponent(ct.id)}/chon`, { pb: p.pb }); toast(`Đã chọn v${p.pb} — bấm Phát hành để áp dụng`); await Promise.all([tai(), moChiTiet(ct.id)]); } catch (e) { baoLoi(e); }
      }));
      const xem = h("button", { type: "button", class: "mini", title: `Nạp nội dung v${p.pb} vào ô sửa bên dưới`, "data-testid": "bd-load", onclick: () => { soan.value = JSON.stringify(p.thaoTac, null, 2); trangThu.value = p.trangThu ?? ""; loiSoan.hidden = true; } }, "Xem/sửa");
      return h("tr", { "data-testid": "bd-version-row", dataset: { pb: String(p.pb) } },
        h("td", {}, `v${p.pb}`), h("td", {}, h("span", { class: `tag ${p.trangThai === "dang_dung" ? "ok" : p.trangThai === "tam_ngung" ? "err" : ""}` }, NHAN_TT[p.trangThai] ?? p.trangThai), laMucTieu ? h("i", { class: "tag warn", style: "font-style:normal;margin-left:4px" }, "sẽ phát hành") : null),
        h("td", { class: "small" }, NHAN_NGUON[p.nguon] ?? p.nguon), h("td", { class: "small" }, p.taoBoi ?? "hệ thống"), h("td", { class: "nowrap small" }, fmtTime(p.taoLuc)),
        h("td", {}, h("div", { class: "row", style: "flex-wrap:nowrap" }, dung, xem)));
    }));

    const loi = ct.loi.length
      ? h("div", { class: "tbl" }, h("table", { "data-testid": "bd-errors" },
        h("thead", {}, h("tr", {}, h("th", {}, "Lúc"), h("th", {}, "Bot"), h("th", {}, "Bước"), h("th", {}, "Loại"), h("th", {}, "Bản"), h("th", {}, "Lý do"))),
        h("tbody", {}, ...ct.loi.map((l) => h("tr", { "data-testid": "bd-error-row", dataset: { loai: l.loai } },
          h("td", { class: "nowrap small" }, fmtTime(l.luc)), h("td", {}, l.botName ?? l.botId), h("td", { class: "bd-code-cell small" }, l.stepId), h("td", { class: "small" }, NHAN_LOI[l.loai] ?? l.loai),
          h("td", { class: "small" }, `v${l.pb} · #${l.banDoSo}`), h("td", { class: "small wrap" }, l.lyDo ?? ""))))))
      : h("p", { class: "empty small", "data-testid": "bd-no-errors" }, "Chưa có bot nào báo lỗi ở thao tác này.");

    const NHAN_PT: Record<PhanTuDung["trangThai"], string> = { con: "còn", mat: "đã mất", moi: "mới", khong_thay: "chưa thấy trong khảo sát" };
    const dsPt = ct.phanTuDung ?? [];
    const phanTu = dsPt.length
      ? h("div", { class: "tbl" }, h("table", { "data-testid": "bd-pt-table" },
        h("thead", {}, h("tr", {}, h("th", {}, "Trang"), h("th", {}, "Phần tử (chữ hoặc selector)"), h("th", {}, "css"), h("th", {}, "Trạng thái"))),
        h("tbody", {}, ...dsPt.map((p) => h("tr", { "data-testid": "bd-pt-row", dataset: { trangThai: p.trangThai } },
          h("td", { class: "small" }, p.trang || "—"), h("td", { class: "small wrap" }, p.nhan || "(không có chữ)"), h("td", { class: "bd-code-cell small" }, p.css ?? ""),
          h("td", {}, h("span", { class: `tag ${p.trangThai === "mat" ? "err" : p.trangThai === "moi" ? "ok" : p.trangThai === "khong_thay" ? "warn" : ""}` }, NHAN_PT[p.trangThai] ?? p.trangThai)))))))
      : h("p", { class: "empty small", "data-testid": "bd-pt-none" }, "Chưa có khảo sát giao diện của mạng này (hoặc thao tác không dùng selector khớp được) — nhập tệp khảo sát để thấy các phần tử.");

    // Tham chiếu từ bản đồ giao diện: tải NGẦM — lỗi/chậm chỉ ghi một dòng, không chặn phần còn lại của chi tiết.
    const thamChieu = h("div", { class: "bd-tc", "data-testid": "bd-tc" }, h("p", { class: "muted small", "data-testid": "bd-tc-cho" }, "Đang so với khảo sát giao diện…"));
    void (async () => {
      let tc: ThamChieuTc;
      try { tc = await api<ThamChieuTc>("GET", `/api/ban-do/thao-tac/${encodeURIComponent(ct.id)}/tham-chieu`); }
      catch (e) { if (alive() && chon === ct.id) { clear(thamChieu); thamChieu.append(h("p", { class: "err small", "data-testid": "bd-tc-loi" }, `Không tải được tham chiếu: ${errMsg(e)}`)); } return; }
      if (!alive() || chon !== ct.id) return;
      clear(thamChieu);
      if (!tc.mucTieu.length) { thamChieu.append(h("p", { class: "empty small", "data-testid": "bd-tc-none" }, "Thao tác này chưa có bước bấm/gõ nào được học (không có gì để đối chiếu).")); return; }
      const NHAN_TC: Record<MucTieuTc["trangThai"], string> = { khop: "khớp", khong_thay: "khảo sát chưa thấy", chua_co_khao_sat: "chưa có khảo sát" };
      for (const m of tc.mucTieu) {
        const dong = h("div", { class: "bd-tc-row", "data-testid": "bd-tc-row", dataset: { trangThai: m.trangThai, buoc: m.buoc } },
          h("div", { class: "row between" },
            h("span", { class: "small wrap" }, h("b", {}, m.buoc), ` · ${m.kind}${m.mota ? ` — ${m.mota}` : ""}`),
            h("span", { class: "row", style: "gap:6px;flex-wrap:wrap" },
              h("span", { class: `tag ${m.trangThai === "khop" ? "ok" : m.trangThai === "khong_thay" ? "warn" : ""}` },
                m.trangThai === "khop" ? `${NHAN_TC.khop} ${m.xacNhan} phần tử` : NHAN_TC[m.trangThai]),
              m.tinCay === "thap" ? h("span", { class: "tag err", "data-testid": "bd-tc-cu", title: "Nhiều bot báo gợi ý/tham chiếu này không dùng được — khảo sát lại trang này rồi nhập tệp mới" }, "có thể cũ — nên khảo sát lại") : null)));
        const bc = m.baoCao;
        if (bc && bc.dung + bc.sai > 0) dong.append(h("p", { class: "muted small", "data-testid": "bd-tc-bao" }, `Bot báo (7 ngày): đúng ${bc.dung} · sai ${bc.sai}${bc.ganNhat ? ` · gần nhất ${fmtTime(bc.ganNhat)}` : ""}`));
        if (m.trangThai === "khong_thay") {
          dong.append(m.goiY.length
            ? h("ul", { class: "bd-tc-goiy", "data-testid": "bd-tc-goiy" }, ...m.goiY.map((g) => h("li", { class: "small wrap", "data-testid": "bd-tc-goiy-item" },
              h("b", {}, g.nhan), ` (${g.trang}${g.trangThai === "moi" ? ", mới" : ""}) `, h("code", { class: "bd-code-cell" }, g.css), " ",
              h("button", { type: "button", class: "mini", "data-testid": "bd-tc-copy", title: "Chép selector này để dán vào phần Sửa nội dung bên dưới",
                onclick: () => { void navigator.clipboard?.writeText(g.css).then(() => toast("Đã chép selector"), () => toast("Không chép được — hãy bôi đen và chép tay", "err")); } }, "Chép css"))))
            : h("p", { class: "muted small", "data-testid": "bd-tc-khong-goiy" }, "Không có gợi ý trong khảo sát — khi chạy, AI sẽ tự tìm phần tử."));
        }
        thamChieu.append(dong);
      }
      thamChieu.append(h("p", { class: "muted small" }, "Đây chỉ là tham chiếu từ lần khảo sát gần nhất — có thể đã cũ hoặc trang chưa được dò. Sai thì bot/AI tự tìm như trước."));
    })();

    chiTiet.append(
      h("div", { class: "row" }, h("h3", { class: "grow", "data-testid": "bd-detail-title" }, `${ct.nenTang}/${ct.ma}`), tagSucKhoe(ct.sucKhoe), tagChuaChac(ct.sucKhoe), h("button", { type: "button", class: "mini", title: "Đóng phần chi tiết", onclick: () => { chon = null; chiTiet.hidden = true; veBang(); } }, "Đóng")),
      h("p", { class: "small muted" }, `Trang gốc: ${ct.urlNenTang} · đang phát hành: ${ct.pbDangDung !== null ? "v" + ct.pbDangDung : "chưa"} · sẽ phát hành tới: ${ct.pbMucTieu !== null ? "v" + ct.pbMucTieu : "tạm ngưng"}`),
      h("h4", {}, "Phiên bản"),
      h("div", { class: "tbl" }, h("table", {}, h("thead", {}, h("tr", {}, h("th", {}, "Bản"), h("th", {}, "Trạng thái"), h("th", {}, "Nguồn"), h("th", {}, "Bởi"), h("th", {}, "Lúc"), h("th", {}))), bangPb)),
      h("h4", {}, "Phần tử giao diện thao tác này dùng"), phanTu,
      h("h4", {}, "Tham chiếu từ bản đồ giao diện (gợi ý, có thể cũ)"), thamChieu,
      h("h4", {}, "Lỗi bot báo gần đây"), loi,
      h("h4", {}, "Sửa nội dung"), soan, h("div", { class: "row" }, trangThu), loiSoan,
      h("div", { class: "row" }, luuMoi, ngung));
  }

  // ---- Phát hành: xem trước thay đổi → xác nhận → gửi kèm số bản đang xem (chống bấm hai lần / hai tab).
  btnPh.addEventListener("click", () => void busy(btnPh, "Đang chuẩn bị…", async () => {
    if (!data?.ban) return;
    const soXem = data.ban.so;
    let ds: ThayDoi[];
    try { ds = await api<ThayDoi[]>("GET", "/api/ban-do/thay-doi"); } catch (e) { baoLoi(e); return; }
    if (!ds.length) { toast("Không có thay đổi nào để phát hành"); await tai(); return; }
    const ghiChu = h("input", { placeholder: "Ghi chú cho bản này (không bắt buộc)", maxlength: 500, "data-testid": "bd-note" });
    // Xem trước "kịch bản sơ đồ nào bị ảnh hưởng": tải NGẦM sau khi hộp đã mở — lỗi/chậm chỉ ghi "không xem trước được", KHÔNG chặn phát hành.
    const xemTruoc = h("div", { class: "bda-preview", "aria-live": "polite", "data-testid": "bd-anh-huong" }, h("p", { class: "muted small", "data-testid": "bd-anh-huong-cho" }, "Đang xem trước kịch bản sơ đồ bị ảnh hưởng…"));
    const nhapLai = h("input", { type: "checkbox", "data-testid": "bd-nhap-lai" });
    nhapLai.checked = false; // MẶC ĐỊNH TẮT — chạy nháp tốn lượt/tài nguyên bot
    const ok = await new Promise<boolean>((xong) => {
      let daDong = false;
      const dong = (v: boolean): void => { daDong = true; wrap.remove(); xong(v); };
      const wrap = h("div", { class: "modal-wrap", role: "dialog", "aria-modal": "true", "data-testid": "bd-confirm" },
        h("div", { class: "modal bda-modal" }, h("h3", {}, `Phát hành bản đồ #${soXem + 1}?`),
          h("p", { class: "small" }, `${ds.length} thay đổi sẽ có hiệu lực ngay cho mọi Boss và bot đang trực tuyến:`),
          h("ul", { class: "small", "data-testid": "bd-changes" },
            ...ds.slice(0, TOI_DA_XEM_TRUOC).map((d) => h("li", {}, `${d.nenTang}/${d.ma}: ${NHAN_LOAI[d.loai] ?? d.loai} (${d.tu !== null ? "v" + d.tu : "—"} → ${d.den !== null ? "v" + d.den : "ngưng"})`)),
            ds.length > TOI_DA_XEM_TRUOC ? h("li", {}, `… và ${ds.length - TOI_DA_XEM_TRUOC} thay đổi khác`) : null),
          xemTruoc,
          h("label", { class: "bda-check", title: "Chỉ chạy NHÁP (không đăng thật) cho kịch bản đã từng nháp và đổi bản dịch. Không bao giờ tự chạy thật." },
            nhapLai, h("span", {}, "Chạy nháp lại tự động cho kịch bản đã từng nháp (chỉ nháp, không bao giờ tự chạy thật)")),
          h("p", { class: "muted small" }, "Để trống ô này thì kịch bản đổi bản dịch dùng bản mới ở lần chạy sau."),
          ghiChu,
          h("div", { class: "row end" },
            h("button", { type: "button", title: "Không phát hành", "data-testid": "bd-confirm-cancel", onclick: () => dong(false) }, "Huỷ"),
            h("button", { type: "button", class: "pri", title: "Phát hành ngay", "data-testid": "bd-confirm-ok", onclick: () => dong(true) }, `Phát hành #${soXem + 1}`))));
      wrap.addEventListener("keydown", (e) => { if (e.key === "Escape") dong(false); });
      document.body.appendChild(wrap);
      void (async () => {
        let timer: number | undefined;
        try {
          const r = await Promise.race([
            api<AnhHuong>("GET", "/api/ban-do/anh-huong"),
            new Promise<never>((_, no) => { timer = window.setTimeout(() => no(new Error(`quá ${CHO_XEM_TRUOC_MS / 1000} giây vẫn chưa có trả lời`)), CHO_XEM_TRUOC_MS); }),
          ]);
          if (!daDong) veXemTruoc(xemTruoc, r);
        } catch (e) {
          if (daDong) return;
          clear(xemTruoc);
          xemTruoc.append(h("p", { class: "small bda-warn", "data-testid": "bd-anh-huong-loi" }, `Không xem trước được: ${errMsg(e)}. Bạn vẫn phát hành được; kịch bản sơ đồ vẫn được dịch lại khi phát hành.`));
        } finally { window.clearTimeout(timer); }
      })();
    });
    if (!ok) return;
    let loiPh: unknown = null;
    let apDung: { so: number; a: ApDung } | null = null;
    apDungBox.hidden = true; clear(apDungBox); // kết quả của lần phát hành trước không còn đúng nữa
    try {
      const r = await api<KqPhatHanh>("POST", "/api/ban-do/phat-hanh", { soHienTai: soXem, ghiChu: ghiChu.value.trim() || null, nhapLai: nhapLai.checked });
      toast(`Đã phát hành bản đồ #${r.so}`);
      hetLoi();
      if (r.apDung) apDung = { so: r.so, a: r.apDung };
    } catch (e) {
      loiPh = e;
      toast(errMsg(e), "err");
    }
    // Tải lại để hiện bản đồ mới nhất; tải lại thành công sẽ xoá hộp lỗi, nên báo lỗi phát hành SAU khi tải xong (nếu không, lỗi chỉ còn là thông báo thoáng qua).
    await Promise.all([tai(), taiLichSu(), chon ? moChiTiet(chon) : Promise.resolve()]);
    if (loiPh) baoLoi(loiPh);
    if (apDung && alive()) { veKetQuaApDung(apDungBox, apDung.so, apDung.a); apDungBox.scrollIntoView({ block: "nearest" }); }
  }));

  btnNhap.addEventListener("click", () => tep.click());
  tep.addEventListener("change", () => void (async () => {
    const f = tep.files?.[0];
    tep.value = "";
    if (!f) return;
    if (f.size > TOI_DA_TEP) { const m = `Tệp “${f.name}” lớn ${(f.size / 1048576).toFixed(1)} MB — tối đa 20 MB`; baoLoi(new Error(m)); toast(m, "err"); return; }
    await busy(btnNhap, "Đang nhập…", async () => {
      try {
        const txt = await docTep(f);
        // Tệp lớn (khảo sát thật có thể > 8 MB, máy chủ chỉ nhận 8 MB mỗi lần) được nén + tách theo mạng; kiểm kích thước TẤT CẢ gói trước khi gửi gói nào.
        const goi = chiaGoiNhap(txt, f.name);
        let loaiCuoi = "";
        let them = 0, boQua = 0;
        const nenTangMoi: string[] = [];
        const trangBoQua: { nenTang: string; ma: string; lyDo: string }[] = [];
        for (let i = 0; i < goi.length; i++) {
          try {
            const r = await api<{ loai: string; them: number; boQua: number; nenTangMoi: string[]; trangBoQua?: { nenTang: string; ma: string; lyDo: string }[] }>("POST", "/api/ban-do/nhap", { tenTep: f.name, noiDung: goi[i]!.noiDung });
            loaiCuoi = r.loai; them += r.them; boQua += r.boQua;
            for (const n of r.nenTangMoi) if (!nenTangMoi.includes(n)) nenTangMoi.push(n);
            trangBoQua.push(...(r.trangBoQua ?? []));
          } catch (e) {
            if (goi.length > 1 && i > 0) throw new Error(`${errMsg(e)} — đã nhập ${i}/${goi.length} mạng trước đó (nhập lại cùng tệp sẽ bỏ qua phần đã có)`);
            throw e;
          }
        }
        hetLoi();
        const loai = loaiCuoi === "khao_sat" ? "khảo sát (lưu làm tư liệu)" : loaiCuoi === "khoi_tuy_chinh" ? "khối tuỳ chỉnh (thành nháp)" : "bản đồ (thành nháp)";
        toast(`Đã nhập ${loai}: ${them} mới, ${boQua} đã có${nenTangMoi.length ? `, nền tảng mới: ${nenTangMoi.join(", ")}` : ""}${goi.length > 1 ? ` — ${goi.length} mạng (tách từng mạng vì tệp lớn)` : ""}${trangBoQua.length ? `. Bỏ qua ${trangBoQua.length} trang không phải giao diện thật (captcha / chưa đăng nhập / rỗng), giữ dữ liệu cũ: ${trangBoQua.slice(0, 4).map((x) => `${x.nenTang}/${x.ma}`).join(", ")}${trangBoQua.length > 4 ? ` (+${trangBoQua.length - 4})` : ""} — đăng nhập mạng đó trên bot rồi dò lại` : ""}`);
        await tai();
      } catch (e) {
        baoLoi(e);
        toast(errMsg(e), "err");
      }
    });
  })());

  btnXuat.addEventListener("click", () => void busy(btnXuat, "…", async () => {
    try {
      const d = await api<unknown>("GET", "/api/ban-do/xuat");
      const a = h("a", { href: URL.createObjectURL(new Blob([JSON.stringify(d, null, 1)], { type: "application/json" })), download: `ban-do-giao-dien-${new Date().toISOString().slice(0, 10)}.json` });
      document.body.append(a); a.click(); a.remove();
    } catch (e) { baoLoi(e); }
  }));

  let hen: number | undefined;
  tim.addEventListener("input", () => { window.clearTimeout(hen); hen = window.setTimeout(() => { q = tim.value.trim(); trang = 1; void tai(); }, 250); });

  void demDeXuat().then(veDem).catch(() => undefined); // nhãn tab "Đề xuất (N)" — lỗi thì giữ nhãn trơn, không chặn trang
  await Promise.all([tai(), taiLichSu()]);
  return () => { window.clearTimeout(hen); huyGd?.(); };
}
